<script>
import { Basket } from "../stores/basket";
import {onMount} from 'svelte';
import { text } from "svelte/internal";
import Default from "../../routes/layouts/default.svelte";
import FiltersBar from "./FiltersBar.svelte";
import Footer from "./Footer.svelte";
import ModalRenderer from "./ModalRenderer.svelte";
    let products = [];
  onMount(() => {
    fetch('https://crm.lamara.in/products/products/productslist').then(res => res.json()).then(res => {
      products = res.data;
    })
  })
</script>

<svelte:head>
    {#if $Basket.show}
        <style>
            body {
                overflow: hidden;
            }
        </style>
    {/if}
</svelte:head>

<div class="modal basket" class:show={$Basket.show}>
    <div class="for-modal-close" on:click|preventDefault={e => Basket.close()}></div>
    <div class="modal-dialog animate__animated animate__slideInDown animate__faster" role="document">
        <div class="modal-content bg-alt">
            <div class="modal-header justify-content-center align-items-center">
                <h5 class="modal-title">YOUR BOX</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" on:click|preventDefault={e => Basket.close()}>
                    <span aria-hidden="true">
                        <!-- <img src="/images/x_mark_grey.png" alt="Close" class="close-icon"> -->
                        <img src="/images/x_mark.png" alt="Close" class="close-icon">
                        <img src="/images/x_mark.png" alt="Close" class="close-icon close-icon-active">
                    </span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        {#if products.length > 0}
                            {#each $Basket.items as item}
                            <div class="row item py-3">
                                <div class="col-4 col-sm-4 col-md-4 col-lg-4">
                                    <img src={item.item_img} class="img-responsive product-thumb">
                                    <h5 class="cake-name">{item.name}</h5>
                                </div>
                                <div class="col-8 col-sm-8 col-md-8 col-lg-8">
                                    {#each item.pricelist_by_avl_sizes as size, i}
                                        {#if size.quantity && size.quantity > 0}
                                            <div class="row">
                                                <div class="col">
                                                    <h6>{size.size} | Rs. {size.cost}</h6>
                                                    <div class="btn-group" role="group">
                                                        <button type="button" class="btn btn-primary" disabled={size.quantity <= 1} on:click|preventDefault={e => {
                                                            let sizes = [...item.pricelist_by_avl_sizes];
                                                            sizes[i].quantity -= 1;
                                                            sizes[i].messages = sizes[i].messages.slice(0, -1);
                                                            Basket.updateItem({
                                                            ...item,
                                                            pricelist_by_avl_sizes: sizes
                                                        })}}><i class="fa fa-minus"></i></button>
                                                        <button type="button" class="btn btn-default">{size.quantity}</button>
                                                        <button type="button" class="btn btn-primary" on:click|preventDefault={e => {
                                                            let sizes = [...item.pricelist_by_avl_sizes];
                                                            sizes[i].quantity += 1;
                                                            sizes[i].messages = [...sizes[i].messages, ""]
                                                            Basket.updateItem({
                                                            ...item,
                                                            pricelist_by_avl_sizes: sizes
                                                        })}}><i class="fa fa-plus"></i></button>
                                                    </div>
                                                    <button class="btn btn-danger" on:click|preventDefault={e => {
                                                        let sizes = [...item.pricelist_by_avl_sizes];
                                                        sizes[i].quantity = 0;
                                                        sizes[i].messages = [];
                                                        Basket.updateItem({
                                                        ...item,
                                                        pricelist_by_avl_sizes: sizes
                                                    })}}><i class="fa fa-trash"></i></button>
                                                </div>
                                            </div>
                                            <div class="row">
                                                {#each (new Array(size.quantity)) as j,k}
                                                    <div class="col-12 my-1">
                                                        <input type="text" maxlength="40"
                                                            placeholder="Message on cake {k+1}"
                                                            bind:value={size.messages[k]}
                                                        />
                                                    </div>
                                                {/each}
                                            </div>
                                        {/if}
                                    {/each}
                                </div>
                            </div>
                            {:else}
                                <div class="col text-center">
                                    <img class="empty-img" src="/images/empty-box.png" alt="box"/>
                                    <div class="info-txt">Your box is empty, <a href="/" class="btn"> add now</a></div>
                                </div>
                            {/each}
                        {/if}
                    </div>
                </div>
            </div>
            {#if $Basket && $Basket.items.length > 0}
                <div class="modal-footer">
                    <a class="btn btn-primary" href="/checkout" on:click={e => $Basket.show = false}>Checkout</a>
                </div>
            {/if}
        </div>
    </div>
</div>
<style lang="scss">
    
    .basket{
        color: #000;
        background: rgba(0,0,0,0.5);

        .item img { 
            border: 2px solid var(--primary);
            border-radius: 8px;
        }
    }

    .modal-dialog {
        border: 5px solid var(--primary);
        // background-image: url("/images/cart-bg.png");
        position: relative;
        border-radius: 34px;
    }

    .modal-dialog::before {
        content: "";
        position: absolute;
        left: 8px;
        right: 8px;
        bottom: 8px;
        top: 8px;
        // border: 2px solid var(--primary);
        z-index: 1;
        border-radius: 24px;
    }

    .modal-content {
        background-color: transparent;
        height: 100%;
        // overflow-y: auto;
    }

    .modal-body {
        max-height: calc(95vh - 100px);
        overflow-y: auto;
    }

    .modal-content::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-image: url("/images/pattern2.png");
        opacity: 1;
        background-repeat: repeat;
    }

    .basket.show {
        display: block;
    }

    .close span {
        font-size: 37px;
    }

    .for-modal-close {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
    }

    .close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
        opacity: 1;
    }

    .close {
        opacity: 1;
        z-index: 9;
    }

    .modal-header .close {
        padding: 1rem 1rem;
        margin: -1rem -0.1rem -1rem auto;
    }

    .close-icon, .close-icon-active {
        width: 24px;
        height: 24px;
    }

    .close-icon-active {
        display: none;
    }
    
    .close:hover .close-icon {
        display: none;
    }

    .close:hover .close-icon-active {
        display: inline-block;
    }

    .modal-header {
        border: none;
    }

    .modal-title {
        position: absolute;
        color: #434343;
        font-family: var(--primary-font);
        left: 50%;
        font-weight: 600;
        transform: translateX(-50%);
    }

    .info-txt {
        font-weight: 600;
        color: #434343;
        font-family: var(--primary-font); 
    }

    @media (min-width: 576px){
        .modal-dialog {
            max-width: 90%;
        }
    }

    .empty-img {
        width: 50%;
    }

    .product-thumb {
        max-width: 150px;
        max-height: 150px;
        margin-bottom: 10px;
    }

    .modal-footer{
        z-index: 1;
        margin: 16px 20px;
    }

    .cake-name {
        font-size: 18px;
    }
</style>